export default __webpack_public_path__ + "static/media/adobe-xd.a6dca99d.svg";